'use strict'

const SET_STORAGE_LIST = 'SET_STORAGE_LIST'

const LOADING_STORAGE_TREE = 'LOADING_STORAGE_TREE'
const LOAD_STORAGE_TREE = 'LOAD_STORAGE_TREE'

import format from 'string-format'
import api from '../../api'
import {Storage, Folder, File} from '../../models'

const initialState = {
	storage_list: [],
	storages: {}
}

const actions = {
	fetchStorage: function ({commit, getters, dispatch}) {
		console.debug("store.storage.actions.fetchStorage()")

		return Promise.all([
			dispatch('')
		])
	},

	list_storage: function ({commit, getters, dispatch, rootState}) {
		console.debug("store.storage.actions.list_storage()")

		return api.storage.storage_list()
			.then(function (response) {
				const storage_list = response.data.map((s_data) => new Storage(s_data, dispatch))
				commit(SET_STORAGE_LIST, storage_list)
			})
	},

	load_tree: function ({commit, getters, dispatch}, {storage}) {
		console.debug(format(
			"store.storage.actions.load_storage_tree( {id}: {name} ) ",
			{id: storage.id, name: storage.name}))

		commit(LOADING_STORAGE_TREE, storage)
		return api.storage.load_storage_tree(storage.id)
			.then(function (response) {
				commit(LOAD_STORAGE_TREE, {storage, tree_data: response.data})
				return true
			})
			.catch(function (error) {
				commit(LOAD_STORAGE_TREE, {storage, tree_data: null})
				throw error
			})
	},
}

const mutations = {
	[SET_STORAGE_LIST](state, storage_list) {
		console.debug("store.storage.mutations.SET_STORAGE_LIST")

		state.storage_list = storage_list
		state.storages = Object.assign({}, ...state.storage_list.map((s) => ({[s.id]: s})))
	},

	[LOADING_STORAGE_TREE](state, storage) {
		storage.tree_load_begin()
	},

	[LOAD_STORAGE_TREE](state, {storage, tree_data}) {
		storage.set_tree(tree_data)
		storage.tree_load_end()
	},
}

const getters = {
	storages: function (state) {
		return state.storages
	},

	storage_list: function (state) {
		return state.storage_list
	},
}

export default {
	namespaced: true,
	state: initialState,
	getters,
	actions,
	mutations
}